import * as React from "react";
import "./PreferenceNumber.component.css";
import { useEffect, useState } from "react";
import { preferencesService } from "../../../../modules/preferences/PreferencesService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ttResetToDefaultButtonDisabled, ttResetToDefaultButton } from "../../../common-strings.util";
export function PreferenceNumber({ type, label, preferenceName, min, max, step, defaultValueFallback = undefined, inline = false, disabled = false, tooltip, tooltipDisabled, tooltipPosition }) {
    const [currentValue, setCurrentValue] = useState(undefined);
    const [defaultValue, setDefaultValue] = useState(undefined);
    useEffect(() => {
        const schemaObj = preferencesService.schema.preferences.properties[preferenceName];
        let defaultVal;
        if (schemaObj !== undefined && schemaObj.type && schemaObj.type === "number") {
            defaultVal = schemaObj.default;
        }
        else if (defaultValueFallback !== undefined) {
            defaultVal = defaultValueFallback;
        }
        setDefaultValue(defaultVal);
        const storedValue = preferencesService.getNumberPreferredValue(preferenceName, defaultVal);
        if (storedValue !== undefined) {
            setCurrentValue(storedValue);
        }
        else {
            setCurrentValue(defaultVal);
        }
    }, []);
    useEffect(() => {
        if (currentValue !== undefined) {
            preferencesService.updatePreferences([{ key: preferenceName, value: currentValue }]);
        }
    }, [currentValue]);
    const handleSliderChange = (event) => {
        setCurrentValue(parseFloat(event.target.value));
    };
    return (React.createElement("div", { className: `preference-number ${disabled ? "preference-number-disabled" : ""}`, style: inline ? { width: "unset" } : {} },
        React.createElement("label", null, label),
        React.createElement("input", { "aria-label": label, type: type === "slider" ? "range" : "number", min: min, max: max, step: step, value: currentValue !== undefined ? currentValue : 0, onChange: handleSliderChange, disabled: disabled, className: type === "slider" ? "preference-number-slider" : "preference-number-input", "data-tooltip": tooltip, "data-tooltip-disabled": tooltipDisabled, "data-tooltip-position": tooltipPosition }),
        React.createElement("button", { className: "icon-button", onClick: () => {
                setCurrentValue(defaultValue);
            }, disabled: currentValue === defaultValue, "data-tooltip": ttResetToDefaultButton(), "data-tooltip-disabled": ttResetToDefaultButtonDisabled(), "data-tooltip-position": tooltipPosition },
            React.createElement(FontAwesomeIcon, { icon: ["fas", "undo"] }))));
}
